export default __webpack_public_path__ + "static/media/Sage's Wrist-straps of Yag.65c9168e.jpg";